const ITEMS = [
    "API 6A",
    "API 6D",
    "Wellhead to Pipeline",
    "Fire-Safe Certified",
    "Sour Service NACE MR0175",
    "Fugitive Emissions ISO 15848-1",
    "Hydrostatically Tested",
    "Manufactured in the UK",
];

const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-3xl font-semibold uppercase tracking-wide text-slate-200 sm:text-4xl">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-tactical" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            data-testid="certifications-marquee"
            className="marquee relative overflow-hidden border-y border-white/10 bg-obsidian-800 py-6"
        >
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
